// extracted by mini-css-extract-plugin
export default {"wrapper":"nz-z","viewport":"oz-z","container":"pz-z","slide":"qz-z"};